export default __webpack_public_path__ + "static/media/cub6.35d2ec67.png";